var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#141215"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4024 29V22.0344H25.7347L26.0838 19.3265H23.4024V17.5976C23.4024 16.8136 23.62 16.2793 24.7443 16.2793L26.1783 16.2787V13.8568C25.9302 13.8238 25.0791 13.7501 24.0888 13.7501C22.0213 13.7501 20.606 15.012 20.606 17.3295V19.3265H18.2677V22.0344H20.606V29H12C11.4477 29 11 28.5523 11 28V12C11 11.4477 11.4477 11 12 11H28C28.5523 11 29 11.4477 29 12V28C29 28.5523 28.5523 29 28 29H23.4024Z",
    fill: "#FACD40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookV2);
export default __webpack_public_path__ + "static/media/facebook-v2.0ab7da30d97ec9528d126c62b8cde3c5.svg";
export { ForwardRef as ReactComponent };